import { Wifi, WifiOff, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import Images from '@/assets/images';

interface NoInternetProps {
    className?: string;
}

export const NoInternet = ({ className }: NoInternetProps) => {
    const handleRetry = () => {
        window.location.reload();
    };

    return (
        <div className={cn(
            "fixed inset-0 z-50 flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm animate-fade-in flex items-center flex-col",
            className
        )}>
            {/* <div className='flex items-center'>
                <svg width="40" height="50" viewBox="0 0 40 50" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <linearGradient id="bGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#059669" /> green-600
                            <stop offset="100%" stopColor="#10b981" /> blue-600
                        </linearGradient>
                    </defs>

                    <rect x="0" y="0" width="12" height="10" fill="#2E3192" transform="skewX(-12)" />
                    <rect x="0" y="18" width="12" height="10" fill="#2E3192" transform="skewX(-12)" />
                    <rect x="0" y="36" width="12" height="10" fill="#2E3192" transform="skewX(-12)" />

                    <path
                        d="M14 0H22C30 0 35 5 35 12C35 16 32 19 28 20C33 21 37 25 37 31C37 39 30 45 22 45H14V0Z"
                        // fill="url(#bGradient)"
                        fill="#1A1A1A"
                    />
                </svg>

                <h1 className="text-3xl font-bold text-[#1A1A1A] ml-0 mb-0">
                    ookYourZone
                </h1>
            
            </div> */}

            <div className='flex items-center'>
                <img src={Images.Logo_BYZ} alt="CO-BYZ" className="h-24 w-24 rounded-xl object-contain" />
            </div>
            <div className="w-full max-w-md p-8 text-center animate-scale-in ">

                <div className="relative mb-6">
                    {/* Animated wifi off icon */}
                    <div className="relative mx-auto w-16 h-16 flex items-center justify-center">
                        <WifiOff className="w-12 h-12 text-destructive animate-pulse" />
                        {/* Ripple effect */}
                        <div className="absolute inset-0 rounded-full border-2 border-destructive/20 animate-ping" />
                        <div className="absolute inset-2 rounded-full border border-destructive/10 animate-ping animation-delay-300" />
                    </div>
                </div>

                <div className="space-y-4 mb-8">
                    <h2 className="text-2xl font-semibold text-foreground">
                        No Internet Connection
                    </h2>
                    <p className="text-muted-foreground leading-relaxed">
                        Please check your internet connection and try again. Make sure you're connected to a network.
                    </p>
                </div>

                <div className="space-y-4">
                    <Button
                        onClick={handleRetry}
                        className="w-full hover-scale"
                        size="lg"
                    >
                        <RotateCcw className="w-4 h-4 mr-2" />
                        Try Again
                    </Button>

                    <div className="flex items-center justify-center space-x-2 text-sm text-muted-foreground">
                        <Wifi className="w-4 h-4" />
                        <span>Waiting for connection...</span>
                    </div>
                </div>

                {/* Connection status indicator */}
                <div className="mt-6 flex justify-center">
                    <div className="flex space-x-1">
                        <div className="w-2 h-2 bg-destructive rounded-full animate-bounce" />
                        <div className="w-2 h-2 bg-destructive rounded-full animate-bounce animation-delay-100" />
                        <div className="w-2 h-2 bg-destructive rounded-full animate-bounce animation-delay-200" />
                    </div>
                </div>
            </div>
        </div>
    );
};